import type { ComponentType } from 'react';

import type { ScenarioGridRowKey } from '@makemydeal/dr-dash-store/types/scenarioGridTypes';

import { AccessoriesRow } from './fields/AccessoriesRow/AccessoriesRow';
import { AcqFeeRow } from './fields/AcqFeeRow/AcqFeeRow';
import { AdjResidualRow } from './fields/AdjResidualRow/AdjResidualRow';
import { AnnualMilesRow } from './fields/AnnualMilesRow/AnnualMilesRow';
import { DueAtSigningRow } from './fields/DueAtSigningRow/DueAtSigningRow';
import { LenderProgramRow } from './fields/LenderProgramRow/LenderProgramRow';
import { RateRow } from './fields/RateRow/RateRow';
import { BalloonPaymentRow } from './fields/BalloonPaymentRow/BalloonPaymentRow';
import { BalloonTermTypeRow } from './fields/BalloonTermTypeRow/BalloonTermTypeRow';
import { DaysToFirstPaymentRow } from './fields/DaysToFirstPaymentRow/DaysToFirstPaymentRow';
import { FlexBuyPercentRow } from './fields/FlexBuyPercentRow/FlexBuyPercentRow';
import { MrmRow } from './fields/MrmRow/MrmRow';
import { PaidByCustomerRow } from './fields/PaidByCustomerRow/PaidByCustomerRow';
import { PaymentFrequencyRow } from './fields/PaymentFrequencyRow/PaymentFrequencyRow';
import { RetailPriceRow } from './fields/RetailPriceRow/RetailPriceRow';
import { SecurityDepositRow } from './fields/SecurityDepositRow/SecurityDepositRow';
import { SellingPriceRow } from './fields/SellingPriceRow/SellingPriceRow';
import { CashDownRow } from './fields/CashDownRow/CashDownRow';
import { CashDueTodayRow } from './fields/CashDueTodayRow/CashDueTodayRow';
import { FeesRow } from './fields/FeesRow/FeesRow';
import { FirstPaymentDateRow } from './fields/FirstPaymentDateRow/FirstPaymentDateRow';
import { FlexBuyAvgPaymentRow } from './fields/FlexBuyAvgPaymentRow/FlexBuyAvgPaymentRow';
import { FlexBuyComparableRow } from './fields/FlexBuyComparableRow/FlexBuyComparableRow';
import { FlexBuyFirstPaymentsRow } from './fields/FlexBuyFirstPaymentsRow/FlexBuyFirstPaymentsRow';
import { FlexBuyNextPaymentsRow } from './fields/FlexBuyNextPaymentsRow/FlexBuyNextPaymentsRow';
import { IncentivesRow } from './fields/IncentivesRow/IncentivesRow';
import { NetCashPayoutRow } from './fields/NetCashPayoutRow/NetCashPayoutRow';
import { PaymentGridOffRow } from './fields/PaymentGridRow/PaymentGridOffRow';
import { PaymentGridRow } from './fields/PaymentGridRow/PaymentGridRow';
import { OutsideLienholderNotApplicableRow } from './fields/OutsideLienholderRow/OutsideLienholderNotApplicableRow';
import { OutsideLienholderRow } from './fields/OutsideLienholderRow/OutsideLienholderRow';
import { ProtectionProductsRow } from './fields/ProtectionProductsRow/ProtectionProductsRow';
import { ResidualRow } from './fields/ResidualRow/ResidualRow';
import { SecondPaymentDateRow } from './fields/SecondPaymentDateRow/SecondPaymentDateRow';
import { TaxesRow } from './fields/TaxesRow/TaxesRow';
import { TermRow } from './fields/TermRow/TermRow';
import { TradeAllowanceRow } from './fields/TradeAllowanceRow/TradeAllowanceRow';
import { TradePayoffRow } from './fields/TradePayoffRow/TradePayoffRow';

export const SCENARIO_ROW_RENDERERS: Record<ScenarioGridRowKey, ComponentType> = {
    retailPrice: RetailPriceRow,
    sellingPrice: SellingPriceRow,
    paymentGrid: PaymentGridRow,
    cashDown: CashDownRow,
    cashDueToday: CashDueTodayRow,
    term: TermRow,
    annualMiles: AnnualMilesRow,
    flexBuyPercent: FlexBuyPercentRow,
    incentives: IncentivesRow,
    rate: RateRow,
    residual: ResidualRow,
    adjResidual: AdjResidualRow,
    mrm: MrmRow,
    acqFee: AcqFeeRow,
    securityDeposit: SecurityDepositRow,
    lenderProgram: LenderProgramRow,
    daysToFirstPayment: DaysToFirstPaymentRow,
    firstPaymentDate: FirstPaymentDateRow,
    secondPaymentDate: SecondPaymentDateRow,
    paymentFrequency: PaymentFrequencyRow,
    flexBuyFirstPayments: FlexBuyFirstPaymentsRow,
    flexBuyNextPayments: FlexBuyNextPaymentsRow,
    flexBuyAvgPayment: FlexBuyAvgPaymentRow,
    flexBuyComparable: FlexBuyComparableRow,
    balloonPayment: BalloonPaymentRow,
    balloonTermType: BalloonTermTypeRow,
    tradeAllowance: TradeAllowanceRow,
    tradePayoff: TradePayoffRow,
    netCashPayout: NetCashPayoutRow,
    accessories: AccessoriesRow,
    protectionProducts: ProtectionProductsRow,
    fees: FeesRow,
    taxes: TaxesRow,
    dueAtSigning: DueAtSigningRow,
    paidByCustomer: PaidByCustomerRow,
    outsideLienholder: OutsideLienholderRow
};

export const SCENARIO_NOT_APPLICABLE_RENDERERS: Partial<Record<ScenarioGridRowKey, ComponentType>> = {
    paymentGrid: PaymentGridOffRow,
    outsideLienholder: OutsideLienholderNotApplicableRow
};
